import { render, staticRenderFns } from "./AddNewPaymentRequest.vue?vue&type=template&id=58f961cd&scoped=true"
import script from "./AddNewPaymentRequest.vue?vue&type=script&lang=ts"
export * from "./AddNewPaymentRequest.vue?vue&type=script&lang=ts"
import style0 from "./AddNewPaymentRequest.vue?vue&type=style&index=0&id=58f961cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f961cd",
  null
  
)

export default component.exports